import React, { memo } from 'react'

//Dependencies.
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import moment from 'moment';

//Slices - data.
import { allActiveChallenges } from '../../../../../slices/challengesSlice';


const ShowComments = () => {
   const params = useParams();
   const activeChallenges = useSelector(allActiveChallenges);
   const { _challengeID } = params;

   const { activeChallengeProperties: { activeChallengeComments } } = activeChallenges[_challengeID];

   return (
      <Container className='p-1 my-3'>
         {
            activeChallengeComments.map((val, ind) => (
               <div className='m-3' key={val._commentID} style={{backgroundColor: ind%2===1 ? 'whitesmoke' : 'beige', border: '5px solid whitesmoke'}}>
                  <strong className={ind%2===1 ? 'text-danger' : 'text-dark'}><em>Posted by: { val.imageLink && <span><img src={val.imageLink} style={{maxHeight: '50px', minWidth: '50px'}} alt='Img. of User' /></span> } <span className='text-danger'>{ val._commentOwnerUsername }</span></em></strong>
                  <strong className={ind % 2 === 1 ? 'text-danger' : 'text-dark'}><em> on <span className='text-danger'>{ moment().format("MMM Do YYYY") }</span></em></strong>
                  <hr />
                  <p>{val.comment}</p>
               </div>
            ))
         }
      </Container>
   )
}

export default memo(ShowComments);